"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9990],{

/***/ 69990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foodProgram_FoodProgramSteps; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/steps/step1.png
/* harmony default export */ var step1 = ({"src":"/_next/static/media/step1.545924ff.png","height":316,"width":312,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVMaXHDys7e6O/p8/bt+f3q9fnn8vfk7fLb5OnM1NjP7+/p6fDt+f/+oiPs9vn6+v/q8/nn8ffh6u/p5NXl+//1fwDut2rxuW31lxnzkg/c5ur2/v/0rExZP1MEAAAAG3RSTlMA+/7j/pi9HPz8CBHo98oziID9/dMc19Goce6qyBFDAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAQUlEQVR4nCXLVw6AIBBAwQcsLNVeg/c/pzHO/3Bfey4ArZ2b8wWOZ7Wxe6gSk4lV8T0mk2REnSxWhgw6hzDp934vXyYCJ48x4BQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/steps/step2.png
/* harmony default export */ var step2 = ({"src":"/_next/static/media/step2.5faf3edb.png","height":316,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEVMaXHn7vTL0dbst4/d6Ojo8fjs9PjJ0dbn8PXs9/vn5t3+rjvr9fr4///T2+DByMvj8fXo9v/q28XywXz0lxnzlBX4dwDy/P/d5+7l7fLxtF6AXAbJAAAAF3RSTlMASvkOFuP3/bfUVvo1Jf79N5yY/HaZS1LHBBcAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA/SURBVHicHctHEsAgDACxpdpAejPJ/x+aGXQX4b4YntaO3QH1O82sQrEuvhdQ86tIntlyX+QtAZympNOIMQI/XmMCTT50B3oAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/steps/step3.png
/* harmony default export */ var step3 = ({"src":"/_next/static/media/step3.1a9e7ee1.png","height":316,"width":340,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAS1BMVEVMaXHU3+XO193n8vr2/v/Bx8u7wMTv+/zu+Pv1+v/q2sDW4OTl8fXp8/fq9fzk7fH3mib2gwDvcwD3oC38r0X0+fvX3+Tf5+z/oyMwLb/PAAAAFnRSTlMA+f5h/v78SM0Q/e9wg905kT4hy/eVcK+iwAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADtJREFUeJwVykkSgCAMAMEBAiG4C0b//1KLWx+au58YwPWNum9Aai1GSfBIKOWtcIjnPMEa3Bed3VQNfjv9AcPuE9XUAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/steps/step4.png
/* harmony default export */ var step4 = ({"src":"/_next/static/media/step4.b2cde593.png","height":316,"width":339,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAATlBMVEVMaXHf5+7P2N3+qzfs9vzm8vr5///jycfEy8/u+f3m8fXv9/ro7fbo7vDr6//h1sLvewD0+f32oCv4myn2gwDK0tjj7PL6///c5Ojs1LA3wCWsAAAAFnRSTlMA8/371WgWAv1Lhfs5zw37IZbLkj77Mp8WIwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADpJREFUeJwFwYkRwCAIAMFTQSD/N5j032h2Oa7bNoCntVUmA/32zKFwjuqeAstc3V8BtGSWAKNHdOwHROQB/YeF5kMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/static_pages/foodProgram/useFoodProgramCta.ts
var useFoodProgramCta = __webpack_require__(31006);
// EXTERNAL MODULE: ./src/static_pages/foodProgram/Utils.tsx
var Utils = __webpack_require__(54397);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/FoodProgramSteps.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: ",
        "px;\n\n  align-items: start;\n  justify-items: center;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var STEPS = [
    {
        titleKey: "steps.1.title",
        descriptionKey: "steps.1.description",
        image: step1
    },
    {
        titleKey: "steps.2.title",
        descriptionKey: "steps.2.description",
        image: step2
    },
    {
        titleKey: "steps.3.title",
        descriptionKey: "steps.3.description",
        image: step3
    },
    {
        titleKey: "steps.4.title",
        descriptionKey: "steps.4.description",
        image: step4
    }, 
];
var FoodProgramSteps = function(props) {
    var theme = (0,styled_components_browser_esm.useTheme)();
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    var ctaHref = (0,useFoodProgramCta/* useFoodProgramCta */.b)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "section",
        textAlign: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils/* FoodProgramH2 */.s, {
                    mb: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                        t: t,
                        i18nKey: "steps.title",
                        components: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                as: "span",
                                color: theme.palette.secondary[400]
                            }, "1"), 
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {
                        children: STEPS.map(function(param) {
                            var titleKey = param.titleKey, descriptionKey = param.descriptionKey, image = param.image;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepImage, {
                                        src: image
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepTitle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                            t: t,
                                            i18nKey: titleKey,
                                            components: {
                                                "1": /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        fontSize: 16,
                                        children: t(descriptionKey)
                                    })
                                ]
                            }, titleKey);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        mt: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                            component: "a",
                            rounded: true,
                            href: ctaHref,
                            target: "_blank",
                            children: t("cta")
                        })
                    })
                ]
            })
        ]
    }));
};
var Steps = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(9);
});
var Step = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var StepImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: props.src,
        width: 160,
        height: 158,
        objectFit: "contain",
        alt: ""
    });
};
var StepTitle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, (0,_object_spread/* default */.Z)({
        lineHeight: {
            xs: 1.5,
            sm: 1.5
        },
        fontSize: 20,
        component: "h3",
        fontWeight: 600
    }, props));
};
/* harmony default export */ var foodProgram_FoodProgramSteps = (FoodProgramSteps);


/***/ })

}]);